<template>
  <div>
    <van-empty
      class="custom-image"
      :image="require('@/assets/result-empty.png')"
    >
      <template slot="description">
        <span v-if="tag">您在近三天内没有参与答题，<br />赶快来参与吧～</span>
        <span v-else>您还没有参与答题，<br />赶快来参与吧～</span>
      </template>
    </van-empty>
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-image {
  padding-top: 120px;
  ::v-deep .van-empty__image {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 125px;
      height: 130px;
    }
  }
  ::v-deep .van-empty__description {
    margin-top: 20px;
    line-height: 20px;
    color: #666;
    text-align: center;
  }
}
</style>
